import Model from '../BaseModel'
import i18n from '@/plugins/i18n'
import axios from '@/plugins/axios'

export default class ProductSalePeriod extends Model {
    resourceName() {
        return 'product-sale-periods'
    }

    fields() {
        return [
            'product_sale_id',
            'installment',
            'price',
            'due_at',
            'payment_method',
            'paid_at',
            'payment_gateway_id',
            'status',
            'price_paid',
            'url',
        ]
    }

    computed() {
        return {
            formattedPaymentMethod(productSalePeriod) {
                return productSalePeriod.getFormattedPaymentMethod(
                    productSalePeriod.payment_method,
                )
            },

            formattedInstallment(productSalePeriod) {
                return productSalePeriod.getFormattedInstallment(
                    productSalePeriod.installment,
                )
            },

            formattedPrice(productSalePeriod) {
                return productSalePeriod.getFormattedPrice(
                    productSalePeriod.price,
                )
            },

            formattedDueAt(productSalePeriod) {
                return productSalePeriod.getFormattedDueAt(
                    productSalePeriod.due_at,
                )
            },

            formattedPaidAt(productSalePeriod) {
                if (!productSalePeriod.paid_at) {
                    return '-'
                }

                if (typeof productSalePeriod.paid_at == 'string') {
                    let paidAt = new Date(productSalePeriod.paid_at)
                    return i18n.d(paidAt, 'datetime')
                }

                return i18n.d(productSalePeriod.paid_at, 'datetime')
            },

            formattedPricePaid(productSalePeriod) {
                if (productSalePeriod.price_paid)
                    return i18n.n(productSalePeriod.price_paid, 'currency')

                return '-'
            },

            resume(productSalePeriod) {
                return (
                    ' no valor de ' +
                    productSalePeriod.formattedPrice +
                    ' referente à parcela ' +
                    productSalePeriod.formattedInstallment +
                    ' com vencimento em ' +
                    productSalePeriod.formattedDueAt
                )
            },
        }
    }

    getFormattedPrice(price) {
        return i18n.n(price, 'currency')
    }

    getFormattedPaymentMethod(paymentMethod) {
        return i18n.t(
            `resources.productSalePeriod.getters.payment_method.${paymentMethod}`,
        )
    }

    getFormattedDueAt(dueAt) {
        if (typeof dueAt == 'string') {
            dueAt = new Date(dueAt)
        }

        return i18n.d(dueAt, 'short')
    }

    getFormattedInstallment(installment) {
        return installment == 0
            ? i18n.t(
                  `resources.productSalePeriod.getters.installment.${installment}`,
              )
            : installment
    }

    get statusColor() {
        switch (this.status) {
            case 'Pendente':
                return 'orange'
            case 'Em dia':
                return 'grey'
            case 'Pago':
                return 'green'
            case 'Pago Atrasado':
                return 'green darken-2'
            case 'Atrasado':
                return 'red'
        }

        return 'black'
    }

    async cancel() {
        return await axios.post(`${this.getSelfUrl()}/cancel`)
    }

    get cancelable() {
        return (
            this.status !== 'Pago' &&
            this.status !== 'Pendente' &&
            this.status !== 'Cancelado'
        )
    }

    get tableColumns() {
        return [
            {
                text: i18n.t(
                    'resources.productSalePeriod.attributes.payment_method',
                ),
                value: 'formattedPaymentMethod',
                align: 'center',
            },
            {
                text: i18n.t(
                    'resources.productSalePeriod.attributes.installment',
                ),
                value: 'formattedInstallment',
                align: 'center',
            },
            {
                text: i18n.t('resources.productSalePeriod.attributes.price'),
                value: 'formattedPrice',
                align: 'center',
            },
            {
                text: i18n.t('resources.productSalePeriod.attributes.status'),
                value: 'status',
                align: 'center',
            },
            {
                text: i18n.t('resources.productSalePeriod.attributes.due_at'),
                value: 'formattedDueAt',
                align: 'center',
            },
            {
                text: i18n.t('resources.productSalePeriod.attributes.paid_at'),
                value: 'formattedPaidAt',
                align: 'center',
            },
            {
                text: i18n.t(
                    'resources.productSalePeriod.attributes.price_paid',
                ),
                value: 'formattedPricePaid',
                align: 'center',
            },
            {
                text: i18n.t('resources.productSalePeriod.attributes.url'),
                value: 'url',
                align: 'center',
            },
        ]
    }
}
